import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';
import { prop } from 'ramda';

import { getPOSData } from '@olxbr/mojo-jojo/selectors/pos';
import { getAdData } from '@olxbr/mojo-jojo/selectors/ad';

import { trackHeaderClick } from '../../core/services/tracking';
import Navbar from './Navbar';

const getName = prop('name');
const getAdId = prop('legacyAdId');
const getListId = prop('listId');
const getFunnelId = prop('funnelId');

const mapStateToProps = state => ({
  adId: getAdId(getAdData(state)),
  listId: getListId(getAdData(state)),
  pointOfSale: getName(getPOSData(state)),
  funnelId: getFunnelId(getPOSData(state)),
});

const configureHandlers = withHandlers({
  handleClick: ({
    adId, listId, pointOfSale, funnelId,
  }) => (btnName) => {
    trackHeaderClick(adId, listId, pointOfSale, btnName, funnelId);
  },
});

export default compose(
  connect(mapStateToProps, null),
  configureHandlers,
)(Navbar);
